import React from "react";

export const hqdsExempt = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#B3B3B3" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 4.80002C10.0905 4.80002 8.25912 5.55859 6.90886 6.90886C5.55859 8.25912 4.80002 10.0905 4.80002 12C4.80002 13.9096 5.55859 15.7409 6.90886 17.0912C8.25912 18.4415 10.0905 19.2 12 19.2C13.9096 19.2 15.7409 18.4415 17.0912 17.0912C18.4415 15.7409 19.2 13.9096 19.2 12C19.2 10.0905 18.4415 8.25912 17.0912 6.90886C15.7409 5.55859 13.9096 4.80002 12 4.80002ZM2.40002 12C2.40002 9.45395 3.41145 7.01215 5.2118 5.2118C7.01215 3.41145 9.45395 2.40002 12 2.40002C14.5461 2.40002 16.9879 3.41145 18.7882 5.2118C20.5886 7.01215 21.6 9.45395 21.6 12C21.6 14.5461 20.5886 16.9879 18.7882 18.7882C16.9879 20.5886 14.5461 21.6 12 21.6C9.45395 21.6 7.01215 20.5886 5.2118 18.7882C3.41145 16.9879 2.40002 14.5461 2.40002 12Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.7884 5.21157C19.0134 5.43661 19.1398 5.74178 19.1398 6.05997C19.1398 6.37817 19.0134 6.68334 18.7884 6.90837L6.90841 18.7884C6.68209 19.007 6.37896 19.1279 6.06433 19.1252C5.74969 19.1224 5.44872 18.9962 5.22623 18.7738C5.00374 18.5513 4.87754 18.2503 4.8748 17.9357C4.87207 17.621 4.99302 17.3179 5.21161 17.0916L17.0916 5.21157C17.3166 4.98661 17.6218 4.86023 17.94 4.86023C18.2582 4.86023 18.5634 4.98661 18.7884 5.21157Z"
        fill="currentColor"
      />
    </svg>
  );
};
